import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/logos/Svelte.svg?component
var Svelte_exports = /* @__PURE__ */ __exportAll({
	default: () => Svelte_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "green",
	viewBox: "-2 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		fill: "#FF3E00",
		d: "M18.664 3.171c-2.219-3.185-6.61-4.13-9.788-2.104L3.29 4.625A6.42 6.42 0 0 0 .398 8.917a6.74 6.74 0 0 0 .666 4.332 6.4 6.4 0 0 0-.959 2.369 6.85 6.85 0 0 0 1.166 5.175c2.219 3.194 6.61 4.137 9.782 2.11l5.586-3.557a6.42 6.42 0 0 0 2.892-4.292 6.74 6.74 0 0 0-.666-4.332 6.4 6.4 0 0 0 .959-2.369 6.94 6.94 0 0 0-1.16-5.182"
	}, null, -1), createElementVNode("path", {
		fill: "#fff",
		d: "M8.327 21.099a4.435 4.435 0 0 1-4.76-1.75 4.16 4.16 0 0 1-.7-3.122q.05-.261.133-.517l.105-.318.286.182a7.1 7.1 0 0 0 2.186 1.095l.208.063-.02.201c-.025.293.055.585.223.83a1.305 1.305 0 0 0 1.779.379l5.581-3.521a1.18 1.18 0 0 0 .524-.783 1.23 1.23 0 0 0-.211-.923 1.305 1.305 0 0 0-1.78-.379l-2.12 1.35q-.53.321-1.135.488a4.435 4.435 0 0 1-4.76-1.75 4.16 4.16 0 0 1-.7-3.122 3.84 3.84 0 0 1 1.736-2.573l5.581-3.559a4.3 4.3 0 0 1 1.134-.485 4.435 4.435 0 0 1 4.76 1.751c.641.908.893 2.03.7 3.122a4 4 0 0 1-.132.517l-.105.318-.287-.182a7.1 7.1 0 0 0-2.186-1.095l-.207-.063.019-.202a1.27 1.27 0 0 0-.223-.83 1.305 1.305 0 0 0-1.779-.378L6.6 9.363a1.18 1.18 0 0 0-.523.783c-.056.323.019.655.21.923a1.305 1.305 0 0 0 1.78.38l2.121-1.35c.352-.214.732-.38 1.134-.485a4.435 4.435 0 0 1 4.76 1.75 4.16 4.16 0 0 1 .7 3.122 3.8 3.8 0 0 1-1.736 2.563l-5.58 3.559c-.353.214-.732.38-1.135.489"
	}, null, -1)])]);
}
var Svelte_default = { render: render$1 };
//#endregion
export { Svelte_exports, Svelte_default as default, render$1 as render };

//# sourceMappingURL=Svelte.svg_component.js.map